'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoShare = function IoShare(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 29.5v-4.6l3-2.4v8.5c0 0.9-0.7 1.5-1.5 1.5h-22.5c-0.9 0-1.5-0.7-1.5-1.5v-17c0-0.9 0.6-1.5 1.5-1.5h9.4c-2.3 1.4-3.4 3-3.4 3h-4.5v14h19.5z m-2.5-12c-6.6 0-9.1 1.9-12.5 7.5 0 0 0.4-12.8 12.5-12.8v-4.7l10 7.5-10 7.5v-5z' })
        )
    );
};

exports.default = IoShare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/share.js
// module id = 2891
// module chunks = 168707334958949